import { Calculator, BarChart3, Receipt, TrendingUp, FileSpreadsheet, PieChart } from 'lucide-react';

const PACKAGES = [
  { name: 'Cơ bản', price: '2.500.000', period: '/tháng', color: '#64748b', features: ['Hạch toán thu chi hàng ngày', 'Báo cáo P&L hàng tháng', 'Khai thuế VAT', 'Hỗ trợ email'], notIncluded: ['Kiểm toán định kỳ', 'Tư vấn tài chính'] },
  { name: 'Chuyên nghiệp', price: '5.500.000', period: '/tháng', color: 'var(--brand)', features: ['Tất cả gói Cơ bản', 'Báo cáo tài chính hàng tuần', 'Quản lý dòng tiền', 'Khai thuế TNCN', 'Hỗ trợ hotline 8h/ngày'], notIncluded: ['Kiểm toán định kỳ'], highlight: true },
  { name: 'Doanh nghiệp', price: '12.000.000', period: '/tháng', color: '#7c3aed', features: ['Tất cả gói Pro', 'Kiểm toán nội bộ hàng quý', 'Tư vấn tài chính chiến lược', 'Dashboard realtime', 'Hỗ trợ 24/7 + Account Manager'], notIncluded: [] },
];
const SERVICES = [
  { icon: <Receipt size={18}/>, title: 'Hạch toán kế toán', desc: 'Ghi nhận toàn bộ giao dịch thu chi, hàng tồn kho, công nợ theo chuẩn mực kế toán Việt Nam.' },
  { icon: <FileSpreadsheet size={18}/>, title: 'Khai báo thuế', desc: 'Kê khai và nộp thuế VAT, TNCN, TNDN đúng hạn. Tư vấn tối ưu nghĩa vụ thuế hợp pháp.' },
  { icon: <BarChart3 size={18}/>, title: 'Báo cáo tài chính', desc: 'Lập báo cáo P&L, bảng cân đối kế toán, lưu chuyển tiền tệ theo yêu cầu.' },
  { icon: <TrendingUp size={18}/>, title: 'Phân tích hiệu quả', desc: 'Phân tích food cost, labor cost, gross profit giúp tối ưu lợi nhuận nhà hàng.' },
  { icon: <PieChart size={18}/>, title: 'Ngân sách & dự báo', desc: 'Lập kế hoạch ngân sách, dự báo doanh thu theo mùa vụ cho chuỗi F&B.' },
  { icon: <Calculator size={18}/>, title: 'Tư vấn định giá', desc: 'Tư vấn định giá menu, phân tích break-even point để tối ưu lợi nhuận.' },
];

export default function HoTroKeToanPage() {
  return (
    <div className="max-w-5xl mx-auto space-y-10 animate-fade-in">
      <div className="rounded-2xl overflow-hidden relative p-8 md:p-12"
           style={{ background: 'linear-gradient(135deg, #0891b2 0%, #06b6d4 50%, #67e8f9 100%)' }}>
        <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle at 20% 50%, white 1px, transparent 1px)', backgroundSize: '30px 30px' }} />
        <div className="relative z-10 flex items-start gap-5">
          <div className="w-16 h-16 rounded-2xl bg-white/20 flex items-center justify-center shrink-0">
            <Calculator size={32} className="text-white" />
          </div>
          <div>
            <p className="text-white/70 text-sm font-medium mb-1">Dịch vụ hỗ trợ</p>
            <h1 className="font-display font-black text-3xl text-white mb-2">Hỗ trợ kế toán nhà hàng</h1>
            <p className="text-white/80 text-base max-w-xl">
              Giải pháp kế toán chuyên biệt cho ngành F&B — từ hạch toán hàng ngày
              đến báo cáo tài chính chiến lược, giúp bạn tập trung vào kinh doanh.
            </p>
          </div>
        </div>
      </div>

      {/* Services */}
      <div>
        <h2 className="font-display font-bold text-xl mb-5" style={{ color: 'var(--text-1)' }}>Dịch vụ kế toán</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {SERVICES.map(s => (
            <div key={s.title} className="fnb-card p-5">
              <div className="w-10 h-10 rounded-xl flex items-center justify-center mb-3"
                   style={{ background: '#cffafe', color: '#0891b2' }}>
                {s.icon}
              </div>
              <h3 className="font-semibold text-sm mb-1.5" style={{ color: 'var(--text-1)' }}>{s.title}</h3>
              <p className="text-xs leading-relaxed" style={{ color: 'var(--text-3)' }}>{s.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Pricing */}
      <div>
        <h2 className="font-display font-bold text-xl mb-5" style={{ color: 'var(--text-1)' }}>Gói dịch vụ</h2>
        <div className="grid sm:grid-cols-3 gap-4">
          {PACKAGES.map(pkg => (
            <div key={pkg.name}
              className={`fnb-card p-6 flex flex-col ${pkg.highlight ? 'ring-2 ring-orange-500 relative' : ''}`}>
              {pkg.highlight && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full text-xs font-bold text-white"
                     style={{ background: 'var(--brand)' }}>
                  Phổ biến nhất
                </div>
              )}
              <p className="font-display font-black text-lg mb-1" style={{ color: 'var(--text-1)' }}>{pkg.name}</p>
              <div className="flex items-end gap-1 mb-4">
                <p className="font-black text-2xl" style={{ color: pkg.color }}>{pkg.price}</p>
                <p className="text-xs mb-1" style={{ color: 'var(--text-3)' }}>{pkg.period}</p>
              </div>
              <ul className="space-y-2 flex-1 mb-5">
                {pkg.features.map(f => (
                  <li key={f} className="flex items-start gap-2 text-xs" style={{ color: 'var(--text-2)' }}>
                    <span className="text-green-500 mt-0.5">✓</span> {f}
                  </li>
                ))}
                {pkg.notIncluded.map(f => (
                  <li key={f} className="flex items-start gap-2 text-xs opacity-40 line-through" style={{ color: 'var(--text-3)' }}>
                    <span>✗</span> {f}
                  </li>
                ))}
              </ul>
              <button className="w-full py-2.5 rounded-xl text-sm font-semibold transition-all"
                      style={pkg.highlight ? { background: 'var(--brand)', color: '#fff' } : { border: '1.5px solid var(--border-c)', color: 'var(--text-2)' }}>
                Đăng ký gói này
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
